function NavigationButtons({
  currentStep,
  totalSteps,
  onPrev,
  onNext,
  onGenerate,
  formType,
}) {
  const isFirstStep = currentStep === 1;
  const isLastStep = currentStep === totalSteps;

  return (
    <div className="navigation-buttons">
      <button
        type="button"
        className="prev-btn"
        onClick={onPrev}
        style={{ display: isFirstStep ? "none" : "inline-flex" }}
      >
        <i className="fas fa-arrow-left"></i> Previous
      </button>

      {!isLastStep && (
        <button type="button" className="next-btn" onClick={onNext}>
          Next <i className="fas fa-arrow-right"></i>
        </button>
      )}

      {isLastStep && (
        <button type="button" className="generate-btn" onClick={onGenerate}>
          <i className="fas fa-envelope"></i>{" "}
          {formType === "interview" ? "Interview Request" : "Quote Check"}
        </button>
      )}
    </div>
  );
}

export default NavigationButtons;
